import $ from 'jquery'

/**
 * Localize the website.
 */
class SelectLocalization {
  constructor() {
    // The code is in the format en-US
    this.code = $('html').attr('lang')

    // The country of en-US is US
    this.country = this.countryFromCode(this.code)

    // The language of en-US is en
    this.language = this.languageFromCode(this.code)
  }

  /**
   * Find the country from the lang code.
   */
  countryFromCode(code) {
    let country = null
    if (code.indexOf('-') > -1) {
      country = code.split('-')[1]
    }

    return country
  }

  /**
   * Find the language from the lang code.
   */
  languageFromCode(code) {
    let language = code
    if (code.indexOf('-') > -1) {
      language = code.split('-')[0]
    }

    return language
  }

  /**
   * Register the handler for the click to select language event.
   */
  listenToSelectLanguage() {
    const handle = this.onSelectLanguage.bind(this)
    $('.language-dropdown').on('keypress click', '.dropdown-item', function(e) {
      if (e.which === 13 || e.type === 'click') {
        handle($(this))
      }
    })
  }

  /**
   * Set the language dropdown to the selected language.
   */
  repopulate() {
    const $button = $('.language-dropdown > button')
    const $selected = $(`.language-dropdown .option-locale-${this.code.toLowerCase()}`)
    const $items = $('.language-dropdown .dropdown-item')
    $button.html($selected.html())
    for (const item of $items) {
      const $item = $(item)
      let locale = $item.data('locale')
      if (this.code === locale) {
        $item.addClass('disabled')
        break
      }
    }
  }

  /**
   * Handle the load event.
   */
  onLoad() {
    this.repopulate()
    this.listenToSelectLanguage()
  }

  /**
   * Handle the click event that chooses a language.
   */
  onSelectLanguage($el) {
    const $option = $el.children('.option-locale')
    $('#loading-language-label').after($option.html())
    $('#loading-language-modal').modal({
      backdrop: 'static',
      keyboard: false,
    })
  }
}

export { SelectLocalization }
